<div class="container-fluid p-4 h-100 overflow-auto">
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <div><h4 class="mb-0 text-secondary">Overall My Score</h4></div>
                <div class="d-flex align-items-end mt-3 mt-md-0">
                    <dx-select-box class="me-3" [items]="shiftOptions" [(value)]="shift" valueExpr="value" displayExpr="text" stylingMode="filled"></dx-select-box>
                    <dx-date-range-box [multiView]="false" [showClearButton]="true" [(value)]="dateRangeFilterValue" stylingMode="filled"></dx-date-range-box>
                    <dx-button stylingMode="text" class="ms-3" icon="export" (onClick)="onExport()"></dx-button>
                </div>
            </div>
            <div class="row align-items-center mb-4">
                <div class="col-sm-8 text-center position-relative">
                    <app-doughnut-chart
                        [from]="fromDate"
                        [to]="toDate"
                        [shiftType]="shift"
                        [centerText]="'Efficiency'"
                        (loaded)="onMainChartLoaded($event)"
                        [loadData]="loadScoreData"
                        [formatMode]="'percent'"
                        [palette]="palette"
                        [useCapitalCaseFormatting]="true">
                    </app-doughnut-chart>
                </div>

                <div class="col-sm-4 col-xl-3 offset-xl-1">
                    <div class="table-responsive rounded-1 border border-1">
                        <table class="table table-borderless mb-0">
                            <thead class="bg-light text-muted small text-uppercase">
                            <tr class="table-light">
                                <th>Type</th>
                                <th>Efficiency</th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (detail of scoreData; track detail) {
                                    <tr class="border-top">
                                        <td class="text-muted">{{ detail.argument | capitalCase }}</td>
                                        <td class="text-muted">{{ detail.value | number:'1.0-2' }}%</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <ng-content select="[intermediate-content]"></ng-content>

            <div class="card border-0">
                <div class="card-header text-secondary border-0 ps-0"><h4>My Score By Function</h4></div>
                <div class="card-body text-center">
                    <div class="d-flex justify-content-center align-items-center flex-wrap gap-4">
                        @for (type of productivityTypes; track type) {
                            <div [ngClass]="showChart(type) ? 'd-block' : 'd-none'">
                                <h5 class="text-muted mb-3">{{ type | capitalCase }}</h5>
                                <div class="position-relative d-inline-block">
                                    <app-next-view-doughnut-chart [item]="nextViewItemByType[type]"></app-next-view-doughnut-chart>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <ng-content select="[bottom-content]"></ng-content>
        </div>
    </div>
</div>
